export const Actions = {
  card: {
    add: 'citi-redirects:card:add',
  },
  tealium: {
    linkTag: 'tealium:link-tag',
    viewTag: 'tealium:view-tag',
  },
};

export const DeviceType = { DESKTOP: 'DESKTOP', PHONE: 'PHONE', TABLET: 'TABLET' };
